module.exports = __webpack_public_path__ + "static/szslyy-84bd7b26b4748e498ad39a42174d1870.jpg";